export default __webpack_public_path__ + "static/media/servicepower-logo.da9f06b2.png";